
export const clearLocalStorageSession = () => {
    const keys = ["uuid", "userId", "userName", "perms", "roles", "profilePic", "access_token_time"];

    keys.forEach(key => localStorage.removeItem(key));
};